import {Organization} from '@catalyst-zero/company-schema/types/Organization'
import {createContext} from 'react'

interface OrganizationContextType {
  organization: Organization | undefined
  setOrganization: (organization: Organization | undefined) => void
}

const OrganizationContext = createContext<OrganizationContextType>({
  organization: undefined,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setOrganization: (_: Organization | undefined) => {}
})

export default OrganizationContext
